import React, { FC } from "react";
import { useDispatch, useSelector } from "react-redux";
import { format, addDays } from "date-fns";
import { useTranslation } from "react-i18next";
import { ImInfo } from "react-icons/im";
import Tooltip from '@material-ui/core/Tooltip';

import Row from "../Layout/Row";
import Col from "../Layout/Col";
import ButtonField from "../Fields/ButtonField";
import { useGetDayName } from "../../helpers/dateHelpers";
import { getFullDayEvents, getTimeLineValues } from "../../helpers/calendarHelpers";
import TimeLine from "./TimeLine";
import CreateEventCalendarBody from "./CreateEventCalendarBody";
import CalendarBody from "./CalendarBody";
import {
    getCalendarEndDate,
    getCalendarSettings,
    getCalendarStartDate,
    getCreateEventMode,
    getWorkTimeEnd,
    getWorkTimeStart,
} from "../../redux/selectors/calendarSelectors";
import {
	getGrouppedTemplatesFilterOptions,
} from "../../redux/selectors/filterOptionsSelectors";
import {
	setCreateEventMode, setSelectedEventIdForPlanning,
	setSelectedTemplateId,
} from "../../redux/actions/calendarActions";
import {
    setCalendarDisplayTypeFilter,
    setPickedDateFilter,
} from "../../redux/actions/filterActions";
import Select from "react-select";
import {filterTemplatesByBranchId} from "../../helpers/helpers";
import {getBranchFilter, getTemplateGroupFilter} from "../../redux/selectors/filterSelectors";
import EventSort from "./EventSort";
import { getUser } from "../../redux/selectors/userSelectors";
import { getEvents } from "../../redux/selectors/eventsSelectors";

const WeekCalendar: FC = () => {
    const dispatch = useDispatch();
    const templateOpts = useSelector(getGrouppedTemplatesFilterOptions);
	const branchId = useSelector(getBranchFilter);
    const templateGroupId = useSelector(getTemplateGroupFilter);
    const calendarStartDate = useSelector(getCalendarStartDate);
    const calendarEndDate = useSelector(getCalendarEndDate);
    const workTimeStart = useSelector(getWorkTimeStart);
    const workTimeEnd = useSelector(getWorkTimeEnd);
    const createEventMode = useSelector(getCreateEventMode);
    const calendarSettings = useSelector(getCalendarSettings);
    const user = useSelector(getUser);
    const events = useSelector(getEvents);
    const days = [
        calendarStartDate,
        addDays(calendarStartDate, 1),
        addDays(calendarStartDate, 2),
        addDays(calendarStartDate, 3),
        addDays(calendarStartDate, 4),
        addDays(calendarStartDate, 5),
        addDays(calendarEndDate, -1),
    ];
    const dayNames = [
        useGetDayName(days[0]),
        useGetDayName(days[1]),
        useGetDayName(days[2]),
        useGetDayName(days[3]),
        useGetDayName(days[4]),
        useGetDayName(days[5]),
        useGetDayName(days[6]),
    ];
    const timeLineValues = getTimeLineValues(
        workTimeStart,
        workTimeEnd,
        "week"
    );
    const { t } = useTranslation();

    // const handleCreateEvent = () => {
    //     newEvent &&
    //         createEventFromAPI(newEvent)
    //             .then(() => {
    //                 // console.log("created event", newEvent);
    //             })
    //             .catch((err) => console.log(err));
    //     // TODO: update resources
    // };

    return (
        <div className="calendar-container">
            <div className="calendar-head">
                <Row>
                    <Col className="calendar-head-event">
                        <Row gap="5px">
                            {!createEventMode ? (
                                <Col>
                                    {user.facturabill_modify && (
                                        <Select
                                            placeholder={t("template")}
                                            menuPortalTarget={document.body}
                                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                            options={filterTemplatesByBranchId(templateOpts, branchId, templateGroupId)}
                                            onChange={(val) => {
                                                dispatch(
                                                    // @ts-ignore
                                                    setSelectedTemplateId(val.value)
                                                );
                                                val &&
                                                dispatch(
                                                    setCreateEventMode(true)
                                                );
                                            }}
                                        />
                                    )}
                                    <EventSort />
                                    {/*<SelectField<string>*/}
                                    {/*    value={selectedTemplateId}*/}
                                    {/*    onChange={(val) => {*/}
                                    {/*        dispatch(*/}
                                    {/*            setSelectedTemplateId(val)*/}
                                    {/*        );*/}
                                    {/*        val &&*/}
                                    {/*            dispatch(*/}
                                    {/*                setCreateEventMode(true)*/}
                                    {/*            );*/}
                                    {/*    }}*/}
                                    {/*    label={t("template")}*/}
                                    {/*    options={templateOpts}*/}
                                    {/*/>*/}
                                </Col>
                            ) : (
                                <>
                                    {/*<Col>*/}
                                    {/*    <ButtonField*/}
                                    {/*        className="add-event-button"*/}
                                    {/*        onClick={handleCreateEvent}*/}
                                    {/*    >*/}
                                    {/*        {t("create_event")}*/}
                                    {/*    </ButtonField>*/}
                                    {/*</Col>*/}
                                    <Col>
                                        <ButtonField
                                            className="add-event-button"
                                            onClick={() => {
                                                dispatch(
                                                    setSelectedTemplateId(null)
                                                );
												dispatch(
													setSelectedEventIdForPlanning(null)
												);
                                                dispatch(
                                                    setCreateEventMode(false)
                                                );
                                            }}
                                        >
                                            {t("cancel")}
                                        </ButtonField>
                                        <EventSort />
                                    </Col>
                                </>
                            )}
                        </Row>
                    </Col>
                    {days.map((day, index) => (
                        <Col
                            className="calendar-head-day"
                            key={index}
                            onClick={() => {
                                dispatch(setCalendarDisplayTypeFilter("day"));
                                dispatch(setPickedDateFilter(day));
                            }}
                        >
                            {dayNames[index]}
                            <br />
                            <Row align="center" justify="center">
                            {format(day, "dd.MM.yyyy")}
                            {getFullDayEvents(day, events).length > 0 && (
                                <Tooltip title={<span style={{ whiteSpace: 'pre-line' }}>{
                                    getFullDayEvents(day, events).map((event, index) => (
                                        <span key={index}>{event.name}{"\n"}</span>
                                    ))
                                }</span>} arrow>
                                    <div>
                                        <ImInfo size="12px" style={{marginLeft: '5px', color: 'red'}} />
                                    </div>
                                </Tooltip>
                            )}
                            </Row>
                        </Col>
                    ))}
                </Row>
            </div>
            <TimeLine timeLineValues={timeLineValues} />
            <div className="calendar-body-container">
                <div className="calendar-body">
                    <div className="body-timeline">
                        {timeLineValues.map((tl, index) => (
                            <React.Fragment key={index}>
                                {tl.showLine && (
                                    <div
                                        className="line"
                                        style={{
                                            marginLeft: `${tl.step}px`,
                                        }}
                                    />
                                )}
                            </React.Fragment>
                        ))}
                    </div>
                    {createEventMode ? (
                        <CreateEventCalendarBody />
                    ) : (
                        <CalendarBody />
                    )}
                </div>
            </div>
        </div>
    );
};

export default WeekCalendar;
